import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';
import { ViewScopeService } from '../services/view-scope.service';
import { AuthStateService } from '../services/auth-state.service';

// Guards the root layout route (and, since canActivate re-fires for every child
// activation under it, effectively every protected page): authorized users reach the
// dashboard, everyone else is sent to the public landing page. Waits for the session-cookie
// check (AuthStateService.ensureInitialized()) so it never judges identity before that
// resolves - see AuthStateService for why bootstrap ordering alone isn't sufficient.
@Injectable({
	providedIn: 'root',
})
export class HomeRedirectGuard implements CanActivate {
	constructor(
		private router: Router,
		private viewScopeService: ViewScopeService,
		private authStateService: AuthStateService
	) { }

	canActivate(): Observable<boolean | UrlTree> {
		return this.authStateService.ensureInitialized().pipe(
			map(() => {
				const id = this.viewScopeService.getCurrentOpertaingUserId();

				if (!isNaN(id) && id > 0) {
					return true;
				}

				return this.router.createUrlTree(['/landing']);
			})
		);
	}
}
